// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"806":"4163ae0c","2366":"1d2671aa"}[chunkId] || chunkId) + "." + {"806":"6be739f25cf11811","2366":"d2b31784556fcc38","5580":"065c0bc840d9fb94","8270":"07ee5811c37b957d"}[chunkId] + ".js";
};